// extracted by mini-css-extract-plugin
export default {"DeprecationBanner":"styles_DeprecationBanner__xbM-c","BannerIcon":"styles_BannerIcon__rQMfe","BannerText":"styles_BannerText__8P6gx"};